import moment from "moment";
import { FormValidationRule } from "../../forms/types";

const isStartBeforeEnd: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (c.inputs && v) {
        const startDate = moment(v[c.inputs[0].id], "YYYY-MM-DD");
        const endDate = moment(v[c.inputs[1].id], "YYYY-MM-DD");

        if (endDate.isBefore(startDate)) {
            valid = false;
            message = `Start date must be before end date`;
        }
    }
    return [valid, message];
};

export default isStartBeforeEnd;
